import { normalizeLeadStatus } from './lead-status.util';

export function getLeadStatusBadgeClass(status?: string | null): string {
  const value = normalizeLeadStatus(status);
  const key = value.toLowerCase();

  if (key === 'closed - won' || key.includes('won')) {
    return 'lead-status-badge lead-status-badge--won';
  }
  if (key === 'closed - lost' || key.includes('lost')) {
    return 'lead-status-badge lead-status-badge--lost';
  }
  if (key === 'moved' || key.includes('mov')) {
    return 'lead-status-badge lead-status-badge--moved';
  }
  if (key === 'assigned' || key.includes('assign')) {
    return 'lead-status-badge lead-status-badge--assigned';
  }
  if (key === 'working' || key.includes('work')) {
    return 'lead-status-badge lead-status-badge--working';
  }
  if (key === 'raw') {
    return 'lead-status-badge lead-status-badge--raw';
  }
  if (key === 'new') {
    return 'lead-status-badge lead-status-badge--default';
  }

  return 'lead-status-badge lead-status-badge--default';
}

export function getAccountStatusBadgeClass(status?: string | null): string {
  const key = String(status ?? '').trim().toLowerCase();

  if (!key) {
    return 'lead-status-badge lead-status-badge--default';
  }
  if (key === 'active' || key === 'approved') {
    return 'lead-status-badge lead-status-badge--won';
  }
  if (key === 'inactive' || key === 'rejected' || key === 'cancelled') {
    return 'lead-status-badge lead-status-badge--lost';
  }
  if (key === 'pending') {
    return 'lead-status-badge lead-status-badge--working';
  }

  return 'lead-status-badge lead-status-badge--default';
}

export function getAccountStatusLabel(status?: string | null): string {
  const value = String(status ?? '').trim();
  return value || 'N/A';
}

export function getCampaignEventTypeBadgeClass(eventType?: string | null): string {
  const key = String(eventType ?? '').trim().toLowerCase();

  if (key.includes('deliver')) {
    return 'lead-status-badge lead-status-badge--won';
  }
  if (
    key.includes('bounce') ||
    key.includes('complaint') ||
    key.includes('reject') ||
    key.includes('fail')
  ) {
    return 'lead-status-badge lead-status-badge--lost';
  }
  if (key.includes('open') || key.includes('click')) {
    return 'lead-status-badge lead-status-badge--working';
  }
  if (key.includes('send') || key === 'sent') {
    return 'lead-status-badge lead-status-badge--assigned';
  }

  return 'lead-status-badge lead-status-badge--default';
}
